import React, { useState, useEffect } from 'react'
import flowApi from 'api/taskFlow'
import { useNavigate, useParams } from 'react-router-dom'
import ChatHistoryList from './ChatHistoryList'
import { dispatch } from 'store'

const ChatHistory = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [chatHistoryData, setChatHistoryData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showNewChat, setShowNewChat] = useState(false)

  useEffect(() => {
    fetchChatHistory()
  }, [])

  const fetchChatHistory = async () => {
    try {
      setLoading(true)
      // Fetch automation/task flow history only
      const response = await flowApi.listTaskFlows({ limit: 10, sortBy: 'createdAt', sortOrder: 'desc' })
      if (response.data && response.data.data) {
        setChatHistoryData(response.data.data)
      }
    } catch (err) {
      console.error('Error fetching chat history:', err)
      setError('Failed to load chat history')
    } finally {
      setLoading(false)
    }
  }


  const handleChatClick = (flow) => {
    navigate(`/dashboard/task-flow-assistant/${flow.flowId}`)
  }

  const onClick = (e, item) => {
    dispatch({ type: 'NAV_ITEM_CLICKED', payload: null })
  }

  if (loading) {
    return (
      <div className="w-full w-full bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="px-4 py-3 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Chat history</h2>
        </div>
        <div className="p-8 text-center">
          <div className="animate-spin h-6 w-6 border-2 border-blue-500 border-t-transparent rounded-full mx-auto"></div>
          <p className="text-sm text-gray-500 mt-2">Loading...</p>
        </div>
      </div>
    )
  }

 

  return (
    <div className="w-full w-full bg-white border border-gray-200 rounded-lg shadow-sm h-full flex flex-col">
      <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">Chat history</h2>
        <button onClick={(e) => onClick(e, null)} className="inline-flex items-center justify-center w-8 h-8 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
        </button>
      </div>

      <ChatHistoryList 
        chatHistoryData={chatHistoryData} 
        onChatClick={handleChatClick} 
        activeFlowId={id}
      />

      {chatHistoryData.length > 0 && (
        <div className="px-4 py-3 border-t border-gray-200 bg-gray-50">
          <button className="w-full text-xs text-gray-600 hover:text-gray-800 transition-colors">
            View All Conversations
          </button>
        </div>
      )}
    </div>
  )
}

export default ChatHistory